import React, { useState, useEffect, useRef } from "react";
import classes from "./styles.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Link } from "react-router-dom";

const DropdownMenuButton = ({
  options = [],
  defualtLabel = "Select",
  variant, // primary , secondary , ternary
  onClick = () => {},
  className,
  buttonBaseClasses,
  menuClassName,
  itemClassName,
  icon,
  trigger = "hover",
}) => {
  // state
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const menuRef = useRef(null); //  initial Object reference

  // toggle // click or double click close
  const handleToggle = () => {
    if (trigger === "click") {
      setIsOpen(prev => !prev);
    }
  };

  //hover mouse enter
  const handleMouseEnter = () => {
    if (trigger === "hover") {
      setIsOpen(true);
    }
  };

  // hover mouse leave
  const handleMouseLeave = () => {
    if (trigger === "hover") {
      setIsOpen(false);
    }
  };

  // must be close on outside click
  useEffect(() => {
    const handleClickOutside = e => {
      if (!menuRef?.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    // cleanup function remove the event handler
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${classes["dropdown"]} ${classes[variant] || ""} ${className || ""}`}
      ref={menuRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`${classes["dropdown_button"]} ${buttonBaseClasses}`}
        onClick={handleToggle}
      >
        {defualtLabel}
        {icon ? icon : <KeyboardArrowDownIcon sx={{ fontSize: "22px" }} />}
      </button>

      {/* Menu */}
      {isOpen && (
        <div className={`${classes["dropdown__menu"]} ${menuClassName}`}>
          {options.map((option, index) => (
            <div
              key={index}
              className={`${classes["dropdown__item"]} ${
                activeIndex === index ? classes["active"] : ""
              } ${itemClassName}`}
              onClick={() => {
                option.onClick?.();
                setIsOpen(false);
              }}
            >
              {option.path ? (
                <Link to={option.path} target={option.target}>
                  {option.label}
                </Link>
              ) : (
                option.label
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenuButton;
